import { motion } from "framer-motion";

export default function Failuremessage(props){
    return <motion.p className="failmessage" variants={
        {
            hidden:{backgroundColor:"#097ABF",height:"0vw",padding:"0vw"},
            visible:{backgroundColor:props.isFail?"rgb(208, 70, 70)":"rgb(78, 184, 97)",height:"4vw",padding:"1vw"}
        }
    } animate={"visible"} initial={"hidden"} transition={{duration:0.5,delay:0.25}}>
        {props.isFail?props.custommessage?props.custommessage:"Failed To Submit, Try Again":props.successmessage?props.successmessage:"Submitted Successfully"}
    </motion.p>
}